export enum LeaseIngestionMutationsEnum {
  UpsertRecord = 'UPSERT_RECORD',
  UpsertRecords = 'UPSERT_RECORDS',
  RemoveRecord = 'REMOVE_RECORD',
  SetListing = 'SET_LISTING',
  SetListingLoading = 'SET_LISTING_LOADING',
  SetListingError = 'SET_LISTING_ERROR',
  SetActiveId = 'SET_ACTIVE_ID',
  SetDetailLoading = 'SET_DETAIL_LOADING',
  SetDetailError = 'SET_DETAIL_ERROR',
}

export enum LeaseIngestionActionsEnum {
  FetchList = 'FETCH_LIST',
  FetchOne = 'FETCH_ONE',
  Upload = 'UPLOAD',
  PatchExtraction = 'PATCH_EXTRACTION',
  Reject = 'REJECT',
  Approve = 'APPROVE',
}
